/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {displayIfNotZero} from "../../../utils/data";
import {RowCell} from "../../atoms/layout/RowCell";
import {useIsMobile} from "../../hoc/hooks";


export const rowCellSizes = {xxs: 6, xs: 6, sm: 3};

const ValueColumn = ({label, value, altValue, width, sizes, isLast, className, hideDesktop = true}) => {

    const altPresent = altValue && displayIfNotZero(altValue) && altValue !== value;
    const isMobile = useIsMobile("1000px");

    return (
        <RowCell sizes={{...sizes, sm: width ? width : sizes.sm}}
                 className={`table-group-cell__value ${isLast ? "is-last" : ""} ${className ? " " + className : ""}`}>
            {label && <label className={`${hideDesktop ? 'hide-desktop' : ''}`}>{label}</label>}
            <span className="p-serif-nr"/>
            <span className={`${isMobile ? 'p-heavy' : ''} ${altPresent ? 'text-lt' : ''}`}>{value}</span>
            {altPresent && <span className={`p-text-promotion ${isMobile ? 'p-heavy' : ''}`}>{altValue}</span>
            }
        </RowCell>
    );
}

ValueColumn.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string,
    altValue: PropTypes.string,
};

ValueColumn.defaultProps = {
    sizes: rowCellSizes,
};

export default ValueColumn;
